import {getLocaleNumberSymbol, NumberSymbol} from '@angular/common';
import {Directive, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, Renderer2} from '@angular/core';
import {DefaultValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Directive({
    selector: 'input[mydocma-currency-input]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CurrencyInputDirective,
            multi: true
        }
    ]
})
export class CurrencyInputDirective extends DefaultValueAccessor implements OnInit {
    private localDecimal = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);
    private regex: RegExp = new RegExp(/^-?[0-9]*(\.[0-9]+)?$/);

    constructor(renderer: Renderer2, private readonly elementRef: ElementRef<any>, @Inject(LOCALE_ID) public locale: string) {
        super(renderer, elementRef, false);
    }

    ngOnInit(): void {
        const initialValue = this.elementRef.nativeElement.value;
        const parsedValue = this.parseInputValue(initialValue);
        if (initialValue !== parsedValue) {
            this.setProperty('value', parsedValue);
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = (value) => {
            const parsedValue = this.parseInputValue(value);
            const controlValue: string = this.elementRef.nativeElement.value;
            if (value && value !== parsedValue) {
                super.setProperty('value', parsedValue);
            }
            if (parsedValue === '-') {
                return;
            }
            const numberValue = parsedValue === '' ? null : parseFloat(parsedValue);
            fn(numberValue);
        };
    }

    // Add a HostListener to handle 'input' events
    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        const parsedValue = this.parseInputValue(value);
        if (value !== parsedValue) {
            this.setProperty('value', parsedValue);
        }
        this.onChange(value);
    }

    private parseInputValue(valueToParse: string): string {
        const decimalPointIndex = valueToParse.lastIndexOf(this.localDecimal);
        if (decimalPointIndex < 0) {
            return valueToParse;
        }
        let fractionPart = valueToParse.substring(decimalPointIndex + 1);
        if (fractionPart.length < 3) {
            return valueToParse;
        }
        fractionPart = fractionPart.substring(0, 2);
        const parsedValue = valueToParse.substring(0, decimalPointIndex + 1) + fractionPart;
        return parsedValue;
    }
}
